class Core {
    constructor() {
        this.currentTimeout = null;
    }
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        }
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    }
}

window.addEventListener("load", function () {
    const dndPromotion = window.libraryMainsite.promotion;
    const core = new Core();

    const $items = $("#Frame3 .gr_effect--item");
    const totalItems = $items.length;

    // mobile không có hover: tap .bxh-title toggle bảng quà, tap ngoài đóng lại
    const $bxh = $("#Frame3 .bxh");
    $bxh.find(".bxh-title, .bxh-prize").on("click", function (e) {
        e.stopPropagation();
        $bxh.toggleClass("active");
    });
    $(document).on("click", function (e) {
        if (!$(e.target).closest(".bxh").length) $bxh.removeClass("active");
    });

    const LOOP_DELAY = 80;
    const FINAL_DELAY = 210;
    const CLEANUP_DELAY = 300;
    const LOOP_ROUNDS = 2;

    function animationTime(prizeIndex) {
        return LOOP_ROUNDS * totalItems * LOOP_DELAY + prizeIndex * FINAL_DELAY + CLEANUP_DELAY;
    }

    async function runRow(fromIndex, toIndex, delay) {
        for (let i = fromIndex; i <= toIndex; i++) {
            if (i > 0) {
                $items.eq(i - 1).removeClass("active");
            }
            $items.eq(i).addClass("active");
            await core.wait(delay);
        }
    }

    async function animationRandom(prizeIndex) {
        const targetIndex = prizeIndex - 1;
        $items.removeClass("active");

        for (let loop = 0; loop < LOOP_ROUNDS; loop++) {
            if (loop > 0) {
                $items.eq(totalItems - 1).removeClass("active");
            }
            await runRow(0, totalItems - 1, LOOP_DELAY);
        }

        $items.eq(totalItems - 1).removeClass("active");
        await runRow(0, targetIndex, FINAL_DELAY);

        setTimeout(() => $items.removeClass("active"), CLEANUP_DELAY);
    }

    // lượt miễn phí reset 00:00 giờ VN mỗi ngày nên đếm về mốc đó, không đếm từ số mock cố định
    const $countdown = $("#Frame3 .box-countdown");
    const VN_OFFSET_MS = 7 * 60 * 60 * 1000;
    const DAY_MS = 24 * 60 * 60 * 1000;

    function renderCountdown() {
        const remain = Math.ceil((DAY_MS - ((Date.now() + VN_OFFSET_MS) % DAY_MS)) / 1000);
        const hh = String(Math.floor(remain / 3600)).padStart(2, "0");
        const mm = String(Math.floor(remain / 60) % 60).padStart(2, "0");
        const ss = String(remain % 60).padStart(2, "0");
        $countdown.text(hh + ":" + mm + ":" + ss);
    }

    renderCountdown();
    setInterval(renderCountdown, 1000);

    const promotionConfig = { timeWait: 3000 };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: promotionConfig,
        animResult: function (listPrize) {
            // engine trả indexImg = tên file icon (item-3), ô vòng quay đánh số từ 1
            const prizeIndex = Number(listPrize[0].indexImg.split("-")[1]);
            promotionConfig.timeWait = animationTime(prizeIndex);
            animationRandom(prizeIndex);
        },
        callback: function () {
            prodTemplate.fnPromotion();
        },
    });
});
